// extracted by mini-css-extract-plugin
export default {"container":"src-constrains-SalesChannelPreviewPageComponents-GeneralCollapseWrapper-css__container--CBnly"};